import { Box, Button, Typography } from '@mui/material';
import React from 'react';

export interface DrawerHeaderProps {
  title: string;
  onClose?: () => void;
  onBack?: () => void;
}

const DrawerHeader = ({ title, onClose, onBack }: DrawerHeaderProps) => (
  <Box mt={6}>
    <Box
      m={3}
      display="flex"
      flexDirection="row"
      justifyContent="space-between"
      alignItems="center"
    >
      <Typography variant="body1">{title}</Typography>
      {onClose && (
        <Button onClick={onClose}>
          <Typography variant="subtitle2" color="textSecondary">
            Close
          </Typography>
        </Button>
      )}
      {onBack && (
        <Button onClick={onBack}>
          <Typography variant="subtitle2" color="textSecondary">
            Back
          </Typography>
        </Button>
      )}
    </Box>
  </Box>
);

export default DrawerHeader;
